import { render, staticRenderFns } from "./EiFooter.vue?vue&type=template&id=c1121c9e&scoped=true&"
import script from "./EiFooter.vue?vue&type=script&lang=js&"
export * from "./EiFooter.vue?vue&type=script&lang=js&"
import style0 from "./EiFooter.vue?vue&type=style&index=0&id=c1121c9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1121c9e",
  null
  
)

export default component.exports